import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionRequiredInputRow } from "../types";

const ModuleVersionInputsTableDescriptionCell = <T extends ModuleVersionRequiredInputRow>({
  item: input,
  ...cellProps
}: TableSimpleCellProps<T>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={input.description} />
    </TableSimpleCell>
  );
};

export default ModuleVersionInputsTableDescriptionCell;
